import { action, observable } from 'mobx';
import { addToMap, HttpClient, IConfig, Optional, setMap } from 'Mri.Web.Common';
import { UserManagerSettings } from 'oidc-client';
import { IWhereClause } from '../DisplayFilters/WhereFilter';

export class WarrantyAlertsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadWhereSearchAsync(
        model: Mri.Web.Internal.Controllers.DisplayAlerts.AlertLogSearchModel
    ): Promise<Mri.WebApi.PagingResult<string> | undefined> {
        const result = await this.httpClient.post<Mri.WebApi.PagingResult<Mri.DisplayAlerts.DisplayAlertLog>>(
            '/api/v1/display-alerts/search',
            model
        );

        if (result) {
            this.alertLogs.push(...result.result);
            const alertGuids = result.result.map(d => d.displayAlertGuid + d.email);

            return {
                limit: result.limit,
                offset: result.offset,
                result: alertGuids,
                returned: result.returned,
                total: result.total,
            };
        }
    }

    @observable
    public alertLogs: Mri.DisplayAlerts.DisplayAlertLog[] = [];
    @observable
    public alertSearchModel: Mri.Web.Internal.Controllers.DisplayAlerts.AlertLogSearchModel = {
            limit: 40,
            offset: 0,
            searchGuid: '',
            where: '',
            displayAlertFilter: defaultDisplayAlertsFilter,
            orderBy: ''
    };
    @observable
    public alertStorage = new WarrantyAlertsStorage();
    private readonly httpClient: HttpClient;
}

class WarrantyAlertsStorage {
    @observable
    public displayAlertFilter = defaultDisplayAlertsFilter;
    @observable
    public orderBy: string[] = [];
    @observable
    public where: IWhereClause[] | undefined;
}

export const defaultDisplayAlertsFilter: Optional<Mri.DisplayAlerts.DisplayAlertFilter> = {};
